exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_wks-ext.js
// module id = 204
// module chunks = 0